var map = {
	"./Airdryers.pdf": "./src/images/Airdryers.pdf",
	"./Arctic.pdf": "./src/images/Arctic.pdf",
	"./CH-D005WD8-12LD.pdf": "./src/images/CH-D005WD8-12LD.pdf",
	"./CH-D90FP.pdf": "./src/images/CH-D90FP.pdf",
	"./Cassette.pdf": "./src/images/Cassette.pdf",
	"./Consol.pdf": "./src/images/Consol.pdf",
	"./Daytona.pdf": "./src/images/Daytona.pdf",
	"./Daytone.pdf": "./src/images/Daytone.pdf",
	"./Duct air conditioners(I).pdf": "./src/images/Duct air conditioners(I).pdf",
	"./Duct.pdf": "./src/images/Duct.pdf",
	"./Majesty.pdf": "./src/images/Majesty.pdf",
	"./Nature.pdf": "./src/images/Nature.pdf",
	"./Supreme Continental Inverter.pdf": "./src/images/Supreme Continental Inverter.pdf",
	"./Supreme Continental.pdf": "./src/images/Supreme Continental.pdf",
	"./Supreme.pdf": "./src/images/Supreme.pdf",
	"./UNITERM.pdf": "./src/images/UNITERM.pdf",
	"./VIP.pdf": "./src/images/VIP.pdf",
	"./Veritas.pdf": "./src/images/Veritas.pdf",
	"./Vital.pdf": "./src/images/Vital.pdf",
	"./cooper-2025.pdf": "./src/images/cooper-2025.pdf",
	"./cooperandhunter-catalog-2024.pdf": "./src/images/cooperandhunter-catalog-2024.pdf",
	"./floortoceling.pdf": "./src/images/floortoceling.pdf",
	"./jonathan.pdf": "./src/images/jonathan.pdf",
	"./СH-D014WD8-30LD.pdf": "./src/images/СH-D014WD8-30LD.pdf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync recursive ^\\.\\/.*\\.pdf$";